import { z } from 'zod'
import { createFileRoute } from '@tanstack/react-router'
import { UserDetail } from '@/features/users/user-detail'

const searchSchema = z.object({
  tab: z.enum(['overview', 'activity', 'audit']).optional().catch('overview'),
})

export const Route = createFileRoute('/_authenticated/users/$userId')({
  validateSearch: searchSchema,
  component: UserDetail,
})
